module.exports = __webpack_public_path__ + "img/premier-agenda-builder.d5616e4a.jpg";